import type { ReportsQueryScope } from '../../reports/domain/reportsQueryScope';
import type { ReportsCustomRange } from '../infra/salesDateRange';
import type { DateRangePreset } from '../infra/salesReportingConstants';
import { getSalesDateRange, formatLocalYmd } from '../infra/salesDateRange';
import type { SalesListRouteParams } from './salesNavigation';
import type { BranchSalesHistoryCashierFilter } from './salesNavigation';

export type SalesListFromReportsOptions = {
  paymentPendingOnly?: boolean;
  screenTitle?: string;
};

function reportsScopeToRouteParams(scope: ReportsQueryScope): SalesListRouteParams['reportsScope'] | undefined {
  const hasProductOrCustomerFilters =
    scope.categoryId != null ||
    scope.itemType !== 'all' ||
    (scope.productId?.trim() ?? '') !== '' ||
    (scope.brandId?.trim() ?? '') !== '' ||
    (scope.supplierId?.trim() ?? '') !== '' ||
    (scope.customerId?.trim() ?? '') !== '';
  if (!hasProductOrCustomerFilters) return undefined;
  return {
    categoryId: scope.categoryId,
    itemType: scope.itemType === 'all' ? null : scope.itemType,
    productId: scope.productId,
    brandId: scope.brandId,
    supplierId: scope.supplierId,
    customerId: scope.customerId,
  };
}

/**
 * Convierte el período y alcance activos de Informes en params para SalesList.
 */
export function salesListParamsFromReportsScope(
  now: Date,
  preset: DateRangePreset,
  custom: ReportsCustomRange | null,
  scope: ReportsQueryScope,
  options?: SalesListFromReportsOptions
): SalesListRouteParams {
  const range = getSalesDateRange(
    now,
    preset,
    preset === 'custom' ? custom : null
  );
  const fromYmd = formatLocalYmd(new Date(range.fromIso));
  const toYmd = formatLocalYmd(new Date(range.toIso));

  let cashierFilter: BranchSalesHistoryCashierFilter = 'all';
  const cashierId = scope.cashierUserId?.trim();
  if (cashierId) cashierFilter = cashierId;

  const search = scope.search?.trim() ?? '';
  const reportsScope = reportsScopeToRouteParams(scope);

  return {
    fromYmd,
    toYmd,
    cashierFilter,
    search: search || undefined,
    paymentPendingOnly: options?.paymentPendingOnly,
    screenTitle: options?.screenTitle ?? 'Ventas del período',
    reportsScope,
  };
}
